import { getPaginatedListTakingCarManagement } from './getPaginatedListTakingCarManagement';
import { generateExcelManangement } from './generateExcelManangement'
import { getCarLots } from './getCarLots';
import { saveTakingCarManagment } from './saveTakingCarManagment'
import { getStateMachine } from './getStateMachine'
import { dispatchAction } from './dispatchAction'
import { repeatTakingCarRequest } from './repeatTakingCarRequest'
import { mapPossibleActionToOptions } from './mapPossibleActionToOptions'
import { getCanDelete } from './getCanDelete'
import { getTakingCarDetails } from './getTakingCarDetails'
import { updateComment } from './updateComment'
import { saveFastStockLoadingData } from './saveFastStockLoadingData'
import { deleteStockCatalogAndStockReference } from './deleteStockCatalogAndStockReference'
import {updateExistingFastStockLoadingData} from './updateExistingFastStockLoadingData'

export const TakingCarManagement = {
    getPaginatedListTakingCarManagement,
    generateExcelManangement,
    getCarLots,
    saveTakingCarManagment,
    getStateMachine,
    dispatchAction,
    repeatTakingCarRequest,
    mapPossibleActionToOptions,
    getTakingCarDetails,
    getCanDelete,
    saveFastStockLoadingData,
    updateComment,
    deleteStockCatalogAndStockReference,
    updateExistingFastStockLoadingData
  }
  